import React from 'react';
import { toast } from 'react-toastify';

/*
  Interactive confirm rendered as a toast — a drop-in replacement for the
  blocking window.confirm(). Returns a Promise that resolves to `true` when
  the user confirms and `false` when they cancel or dismiss it.

  Usage:
    if (await confirmToast('Delete this product?')) {
      // ...proceed
    }
*/
export const confirmToast = (
  message,
  { confirmText = 'Yes', cancelText = 'Cancel' } = {}
) =>
  new Promise((resolve) => {
    let answered = false;

    const finish = (result, closeToast) => {
      answered = true;
      resolve(result);
      closeToast();
    };

    toast.warning(
      ({ closeToast }) => (
        <div style={{ padding: '2px' }}>
          <p
            style={{
              margin: '0 0 12px',
              fontWeight: 600,
              fontSize: '0.95rem',
              lineHeight: 1.35
            }}
          >
            {message}
          </p>

          <div
            style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}
          >
            <button
              type="button"
              onClick={() => finish(false, closeToast)}
              style={{
                border: 'none',
                borderRadius: '8px',
                padding: '6px 16px',
                fontWeight: 600,
                cursor: 'pointer',
                background: 'rgba(255,255,255,0.9)',
                color: '#7c2d12'
              }}
            >
              {cancelText}
            </button>

            <button
              type="button"
              onClick={() => finish(true, closeToast)}
              style={{
                border: 'none',
                borderRadius: '8px',
                padding: '6px 16px',
                fontWeight: 700,
                cursor: 'pointer',
                background: '#7c2d12',
                color: '#fde68a'
              }}
            >
              {confirmText}
            </button>
          </div>
        </div>
      ),
      {
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
        draggable: false,
        onClose: () => {
          if (!answered) resolve(false);
        }
      }
    );
  });
